import {useHeaderHeight} from '@react-navigation/elements';
import type {StackScreenProps} from '@react-navigation/stack';
import {observer} from 'mobx-react-lite';
import {useCallback} from 'react';

import {useRoot} from '../../Root';
import type {RootStackParamList} from '../../RootStack/RootStackParamList';
import ListCitiesScreen from '../../screens/ListCitiesScreen';
import useCitiesByName from './useCitiesByName';

export type ListCitiesBindingProps = StackScreenProps<
  RootStackParamList,
  'ListCities'
>;

export default observer(function ListCitiesBinding(
  props: ListCitiesBindingProps,
) {
  const {route, navigation} = props;
  const {name = ''} = route.params ?? {};
  const headerHeight = useHeaderHeight();

  const root = useRoot();

  const onCityNameChange = useCallback(
    (name: string) => {
      navigation.setParams({name});
    },
    [navigation],
  );

  const listGroups = useCallback(
    (id: number) => {
      navigation.navigate('ListGroups', {cityId: `${id}`});
    },
    [navigation],
  );

  const favoriteIds = root.favoritesStorage.current?.cities.map(_ => _.id);
  const {search, favorites} = useCitiesByName({name, favoriteIds});

  return (
    <ListCitiesScreen
      cityName={name}
      onCityNameChange={onCityNameChange}
      placeholder="Начните вводить город"
      favorites={name ? null : favorites}
      search={search}
      onCityPress={listGroups}
      compensateHeaderHeight={headerHeight}
    />
  );
});
